import { cacheDom } from '../utils/QuerySelectors.js'
import { getProductsBySkus } from '../utils/Product.js'
import { addLineItems } from '../utils/Cart.js'
import { customerUpdateByAdmin, updateMarketingConsent, searchOrder, formatOrder } from '../utils/Customer.js'

const dom = {}
const qs = {
  orderSection: 'data-section-type="main-order"',
  accountSection: 'data-section-type="main-account"',
  orderReturn: 'data-order-return',
  wishlist: 'data-account-wishlist',
  continueShopping: 'data-account-continue-shopping',
  accountCountry: 'data-account-country',
  accountNewsletter: 'data-account-newsletter',
  addressAdd: 'data-address-add',
  newAddressData: 'data-new-address-data',
  navMobileSelected: 'data-mobile-selected',
  navMobileSelectedTitle: 'data-mobile-selected-title',
  preferenceSave: 'data-email-preferences-save',
}

const qsAll = {
  returnables: 'data-returnable',
  returnableESWs: 'data-returnable-esw',
  reasonSelectors: 'data-return-reason',
  removeFromWishlist: 'data-wishlist-remove',
  addToCartFromWishlist: 'data-wishlist-atc',
  accountNavItems: 'data-account-item',
  shoppingPreferences: 'data-account-preferences',
  editAddressBtns: 'data-address-edit',
  removeAddressBtns: 'data-confirm-message',
  wishlistCounts: 'data-account-wishlist-count',
}

const state = {
  emailPreferencesUpdated: false,
  shoppingPreferences: null,
  accountCountry: null,
  accountNewsletter: null,
}

const getPreferences = () => {
  const shoppingPreferences = Array.from(document.querySelectorAll(`[${qsAll.shoppingPreferences}]:checked`))
    .map(preference => preference.value)
  const accountCountry = dom.accountCountry.value
  const accountNewsletter = dom.accountNewsletter.checked
  return {
    shoppingPreferences,
    accountCountry,
    accountNewsletter
  }
} 
const setPreferencesState = () => {
  const { shoppingPreferences, accountCountry, accountNewsletter } = getPreferences()
  state.shoppingPreferences = shoppingPreferences
  state.accountCountry = accountCountry
  state.accountNewsletter = accountNewsletter
}
const preferenceUpdated = () => {
  const { shoppingPreferences, accountCountry, accountNewsletter } = getPreferences()
  return JSON.stringify(state.shoppingPreferences) != JSON.stringify(shoppingPreferences) || 
    state.accountCountry != accountCountry ||
    state.accountNewsletter != accountNewsletter
}
const updatePreferenceButton = () => {
  setTimeout(() => {
    const updated = preferenceUpdated()
    dom.preferenceSave.classList.toggle('button--primary', updated)
    dom.preferenceSave.disabled = !updated
  }, 300)
}

const updateActionsVisibility = (swatProducts) => {
  if(dom.continueShopping) {
    if (swatProducts.length > 0) {
      dom.continueShopping.classList.remove('flex')
      dom.continueShopping.classList.add('hidden')
    } else {
      dom.continueShopping.classList.add('flex')
      dom.continueShopping.classList.remove('hidden')
    }
  }
}

const onSuccess = (removedProduct) => {
  console.log(`Successfully removed many Products from the List`, removedProduct)
  _swat.fetch((products) => {
    updateActionsVisibility(products)
    updateCounts(products)
  })
}

const onError = (error) => {
  console.log('Error while removing many Products from the List', error)
}

const updateCounts = (products) => {
  const skus = products.map((product) => product.sku).filter(Boolean)
  if (skus.length > 0) {
    getProductsBySkus((results) => {
      const count = products.filter(product => results.filter(r => r.node.variants.edges.filter((e) => e.node.sku == product.sku).length > 0).length > 0).length
      dom.wishlistCounts.forEach(wishlistCount => {
        wishlistCount.innerHTML = count
        if(wishlistCount.closest('.header-wishlist-count')) wishlistCount.closest('.header-wishlist-count').classList.toggle('!hidden', count == 0)
      })
    }, skus)
  }
}

export const setupAccount = () => {
  cacheDom(dom, qs, qsAll)

  const historyPath = '/account#order_history'
  const preferencesPath = '/account#email_preferences'
  let selected = null
  dom.accountNavItems.forEach((navItem) => {
    if (location.href.includes(navItem.href)) selected = navItem
  })
  if (dom.navMobileSelectedTitle) dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
  if(location.pathname.includes('/account')) {
    setTimeout(() => {
      window.scrollTo({
        left: 0, 
        top: 0, 
        behavior: "smooth",
      })
    }, 500)
    setTimeout(() => {
      window.scroll(0, 0)
    }, 1000)
  }
  if (location.hash == '#order_history') {
    let selected = null
    dom.accountNavItems.forEach((navItem) => {
      navItem.classList.toggle('underline', navItem.href.includes(historyPath))
      navItem.classList.toggle('hover:underline', !navItem.href.includes(historyPath))
      if (navItem.href.includes(historyPath)) selected = navItem
    })
    dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
  }
  if (location.hash == '#email_preferences') {
    let selected = null
    dom.accountNavItems.forEach((navItem) => {
      navItem.classList.toggle('underline', navItem.href.includes(preferencesPath))
      navItem.classList.toggle('hover:underline', !navItem.href.includes(preferencesPath))
      if (navItem.href.includes(preferencesPath)) selected = navItem
    })
    dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
  }
  dom.accountNavItems.forEach((navItem) => {
    navItem.addEventListener('click', () => {
      dom.accountNavItems.forEach((item) => {
        item.classList.toggle('underline', item == navItem)
        item.classList.toggle('hover:underline', item != navItem)
      })
      dom.navMobileSelectedTitle.innerHTML = navItem.innerHTML.trim()
    })
  })

  if (dom.navMobileSelected) {
    dom.navMobileSelected.addEventListener('click', (e) => {
      e.stopPropagation()
      dom.navMobileSelected.classList.toggle('account-mobile-nav-selected')
    })
    window.addEventListener('click', () => {
      dom.navMobileSelected.classList.remove('account-mobile-nav-selected')
    })
  }

  if (dom.orderSection) {
    searchOrder((data) => {
      if(data.order) {
        dom.returnables.forEach(returnable => {
          const itemId = returnable.getAttribute(qsAll.returnables)
          const returnableESW = document.querySelector(`[data-returnable-esw="${itemId}"]`)
          if(data.order?.shippingAddress?.countryCodeV2 != 'US') {
            returnable.classList.toggle('!hidden', true)
            returnableESW.classList.toggle('!hidden', false)
          } else {
            returnable.classList.toggle('!hidden', false)
            returnableESW.classList.toggle('!hidden', true)
          }
        })
        
        // dom.returnables.forEach(returnable => {
        //   const itemId = returnable.getAttribute(qsAll.returnables)
        //   const returnableESW = document.querySelector(`[data-returnable-esw="${itemId}"]`)
        //   const hasReturnableItems = data.order.lineItems.edges.filter(edge => edge.node.id.includes(itemId) && edge.node.currentQuantity > 0 && edge.node.refundableQuantity > 0)

        //   const isESW = data.order.fulfillments.filter(f => f.status == 'SUCCESS' && f.location?.name == 'ESW' && f.fulfillmentLineItems?.edges?.filter(e => e.node.lineItem?.id?.includes(itemId)).length > 0).length > 0

        //   returnable.classList.toggle('!hidden', !(hasReturnableItems.length && !isESW))
        //   returnableESW.classList.toggle('!hidden', !(hasReturnableItems.length && isESW))
        // })

        dom.reasonSelectors.forEach((reasonSelector) => {
          reasonSelector.addEventListener('change', () => {
            window.initOrderReturn(
              reasonSelector.getAttribute(`${qsAll.reasonSelectors}`),
              dom.orderReturn,
              reasonSelector.value,
              formatOrder(data.order),
            )
          })
        })
      }
    },
    { 
      number: window.orderNumber 
    })
  }
  

  dom.wishlistCounts = document.querySelectorAll(`[${qsAll.wishlistCounts}]`)
  const swatInterval = setInterval(() => {
    if (typeof _swat != 'undefined' && _swat && _swat.fetch) {
      clearInterval(swatInterval)
      setTimeout(() => {
        _swat.fetch((products) => {
          console.log(products)
          updateActionsVisibility(products)
          
          updateCounts(products)

          const skus = products.map((product) => product.sku).filter(Boolean)
          if (skus.length > 0) {
            
            getProductsBySkus((results) => {
              console.log('swym products', results)
              products.forEach((product) => {
                const result = results.filter(
                  (r) => r.node.variants.edges.filter((e) => e.node.sku == product.sku).length > 0,
                )[0]
                if (!!result && !!dom.wishlist) {
                  const node = result.node
                  const variant = node.variants.edges.filter((e) => e.node.sku == product.sku)[0]
                  const imageUrl = variant?.node?.image?.url || node.featuredImage.url
                  const varintId = variant?.node?.id.replace('gid://shopify/ProductVariant/', '')
                  console.log('variant', variant)
                  dom.wishlist.innerHTML += `
                    <div class="account-wishlist-item text-xs relative flex flex-col justify-between" data-wishlist-item>
                      <div class="relative">
                        <a href="/products/${node?.handle}?variant=${varintId}">
                          ${imageUrl ? '<img class="w-full h-auto block mb-5" src="' + imageUrl + '&width=200' + '" />' : ''}
                          <div class="mb-2.5">${node.title}</div>
                        </a>
                        <div class="mb-2.5">${window.currencySymbol}${variant?.node?.price?.amount}</div>
                        <details class="flex flex-col-reverse gap-1">
                          <summary class="cursor-pointer underline inline-block normal-case">
                            <span>${window.accountStrings.wishlist.viewDetails}</span>
                            <span>${window.accountStrings.wishlist.viewLess}</span>
                          </summary>
                          <div class="flex flex-col gap-1">
                            <div>${window.productStrings.size}:&nbsp;${variant?.node?.selectedOptions[1]?.value}</div>
                            <div>${window.productStrings.color}:&nbsp;${variant?.node?.selectedOptions[0]?.value}</div>
                          </div>
                        </details>
                      </div>
                      ${
                        variant?.node?.availableForSale
                          ? `<button class="button button--secondary w-full mt-6.25 ${Shopify.country == 'JP' ? '!text-xs' : ''}" data-wishlist-atc="` +
                            varintId +
                            `">${window.productStrings.addToBag}</button>`
                          : `<button class="button button--secondary w-full mt-6.25 opacity-50 ${Shopify.country == 'JP' ? '!text-xs' : ''}" disabled>${window.productStrings.soldOut}</button>`
                      }
                      <button class="text-white cursor-pointer z-1 absolute right-3.75 top-3.75 w-2.5 h-2.5" data-wishlist-remove="${variant?.node?.sku}">
                        ${window.globalIcons['icon-close']}
                      </button>
                    </div>
                  `
                }
              })
              const atcBtns = document.querySelectorAll(`[${qsAll.addToCartFromWishlist}]`)
              atcBtns.forEach((atcBtn) => {
                atcBtn.addEventListener('click', () => {
                  atcBtn.disabled = true
                  addLineItems(
                    (cart) => {
                      atcBtn.innerHTML = window.productStrings.added
                      window.initMiniCart(cart, true)
                      window.openCart(true)
                    },
                    [
                      {
                        id: atcBtn.getAttribute(qsAll.addToCartFromWishlist),
                        quantity: 1,
                      },
                    ],
                    atcBtn,
                  )
                })
              })
              const removeBtns = document.querySelectorAll(`[${qsAll.removeFromWishlist}]`)
              removeBtns.forEach((removeBtn) => {
                removeBtn.addEventListener('click', () => {
                  const sku = removeBtn.dataset.wishlistRemove
                  const swymProducts = products.filter((product) => product.sku == sku)
                  if (swymProducts.length > 0) {
                    _swat.removeFromWishList(swymProducts[0], onSuccess, onError)
                    removeBtn.closest('[data-wishlist-item]').remove()
                  }
                })
              })
            }, skus)
          }
        })

        let event = 'sw:addedtowishlist'
        let listener = function(e) {
          _swat.fetch((products) => {
            updateCounts(products)
          })
        }
        // Add listener for the 'addedtowishlist' event to the Swym Event Layer
        _swat.evtLayer.addEventListener(event, listener)
        
        event = 'sw:removedfromwishlist'
        // Add listener for the 'removedfromwishlist' event to the Swym Event Layer
        _swat.evtLayer.addEventListener(event, listener)        
      }, 500)
    }
  }, 300)

  //Start:  Email Preferences
  setPreferencesState()
  
  dom.shoppingPreferences.forEach((shoppingPreference) => {
    shoppingPreference.addEventListener('input', () => {
      updatePreferenceButton()
    })
  })
  if (dom.accountNewsletter) {
    dom.accountNewsletter.addEventListener('input', () => {
      updatePreferenceButton()
    })
  }
  if (dom.accountCountry) {
    dom.accountCountry.addEventListener('change', () => {
      updatePreferenceButton()
    })
  }
  if(dom.preferenceSave) {
    dom.preferenceSave.addEventListener('click', () => {
      const values = dom.shoppingPreferences.filter((p) => p.checked).map((p) => p.value)
      dom.preferenceSave.disabled = true
      dom.preferenceSave.classList.add('button--loading')
      customerUpdateByAdmin(
        (customer) => {
          console.log('update email preferences', customer)

          updateMarketingConsent(
            (customer) => {
              console.log('update email preferences', customer)
              window.customerInfo = customer
              setPreferencesState()
              dom.preferenceSave.classList.remove('button--loading', 'button--primary')
            },
            {
              customer: {
                customerId: window.customerInfo.id,
                emailMarketingConsent: dom.accountNewsletter.checked
                  ? {
                      consentUpdatedAt: new Date().toISOString(),
                      marketingOptInLevel: 'SINGLE_OPT_IN',
                      marketingState: 'SUBSCRIBED',
                    }
                  : {
                      marketingState: 'UNSUBSCRIBED',
                    },
              },
            },
          )
        },
        {
          customer: {
            id: window.customerInfo.id,
            metafields: [
              window.customerInfo.shoppingPreferences
                ? {
                    id: window.customerInfo.shoppingPreferences.id,
                    value: JSON.stringify(values),
                  }
                : {
                    namespace: 'custom',
                    key: 'shopping_preferences',
                    type: 'list.single_line_text_field',
                    value: JSON.stringify(values),
                  },
              window.customerInfo.country
                ? {
                    id: window.customerInfo.country.id,
                    value: dom.accountCountry.value,
                  }
                : {
                    namespace: 'custom',
                    key: 'country',
                    type: 'single_line_text_field',
                    value: dom.accountCountry.value,
                  },
            ],
          },
        },
      )
    })
  }
  //End:  Email Preferences

  // Start: Address page
  if (dom.addressAdd) {
    dom.addressAdd.addEventListener('click', (e) => {
      const newAddressData = JSON.parse(dom.newAddressData.innerHTML)
      newAddressData.country = 'United States'
      window.openAddressForm(newAddressData)
    })
  }
  dom.editAddressBtns.forEach((editAddress) => {
    editAddress.addEventListener('click', (e) => {
      window.openAddressForm(
        JSON.parse(e.target.closest('[data-address]').querySelector('[data-edit-address-data]').innerHTML),
      )
    })
  })
  dom.removeAddressBtns.forEach((removeAddressBtn) => {
    removeAddressBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (confirm(removeAddressBtn.dataset.confirmMessage)) {
        fetch(removeAddressBtn.dataset.target, {
          method: 'DELETE',
        })
          .then((response) => response.text())
          .then((response) => {
            location.reload()
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
    })
  })
  // End: Address page
}
